import React from 'react';
import {UIView} from '@uirouter/react';

export const MapMain = (props) =>  ( <UIView/>);
export default MapMain;
